var _link, _image;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEstrellafull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    enableBackground: "new 0 0 14 14",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _link || (_link = /*#__PURE__*/React.createElement("link", {
    xmlns: "",
    type: "text/css",
    id: "dark-mode",
    rel: "stylesheet",
    href: ""
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 14,
    height: 14,
    x: 0,
    y: 0,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAMAAAAolt3jAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAXVBMVEUAAAD/x3v/x3v/xXr/ w3z/yHr/x3j/xXX/yHv/yHv/z3D/xnv/yHv/yXn/x3z/xnz/x33/x3r/xXr/x3r/xnr/v4D/x3j/ znv/xXr/xnv/xnn/ynr/xnr/x3v///8HoJ9QAAAAHXRSTlMA379gQK8gMI/vEHBwUIDvYGAw37AQ QB+AoFAwkBNMhHEAAAABYktHRB5yCiArAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH5wIV DgQh+AmNBwAAAGBJREFUCNdtzssSgCAIBVDMsrLS3tnj/v9vppGNi1gAZxgYiP5CZKkkkKdDoIi9 KisAtSy1R4MkcmpTdkTmg+3D7vBKjHxrYs6sJU6Za1izPm0PHWC02oGD33AqlPPyb9xfJQoA6YDR LwAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMy0wMi0yMVQxNDowNDozMyswMDowMNA++vEAAAAldEVY dGRhdGU6bW9kaWZ5ADIwMjMtMDItMjFUMTQ6MDQ6MzMrMDA6MDChY0JNAAAAKHRFWHRkYXRlOnRp bWVzdGFtcAAyMDIzLTAyLTIxVDE0OjA0OjMzKzAwOjAw9nZjkgAAAABJRU5ErkJggg=="
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstrellafull);
export default __webpack_public_path__ + "static/media/estrellafull.1928fa5a.svg";
export { ForwardRef as ReactComponent };